<template>
  <div
    class="product"
    @touchmove="getScrollTop"
    @touchend="goimgs"
  >
    <van-nav-bar
      title="商品详情"
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <van-swipe
      class="my-swipe"
      :autoplay="sp?30000:3000"
      indicator-color="white"
    >
    <van-swipe-item v-if="sp">
      <div class="sp">
        <div  @click="spy" v-show="lb" class="xlb">
          <img src="../../assets/xlb.png" alt="">
        </div>
        <div  @click="jspy" v-show="!lb" class="xlb">
          <img src="../../assets/jxlb.png" alt="">
        </div>
      <video id="vi" muted autoplay loop webkit-playsinline="" playsinline="" :src="sp" ></video>

      </div>
    </van-swipe-item>
      <van-swipe-item
        @click="look(i)"
        v-for="(v, i) in img_list"
        :key="i"
      ><img
          :src="v.image"
          alt=""
        /></van-swipe-item>
    </van-swipe>
    <div class="operation">
      <p
        v-show="jf"
        class="money"
      >
        {{ login == 0 ? '价格登录可见' : '￥' + min + '~' + max }}
        <span>购买可获得{{ Math.ceil(max) }}积分</span>
      </p>
      <p
        v-show="!jf"
        class="money"
      >
        <span>购买可获得{{ Math.ceil(max) }}积分</span>
      </p>
      <p class="title">{{ names }}</p>
      <div
        class="equity"
        @click="toRule"
      >
        <div class="left">会员权益介绍</div>
        <div class="right">立即查看</div>
      </div>

      <div></div>
    </div>
    <div
      class="selected"
      @click="onClickSpecs"
    >
      <div class="left">
        规格
        <div style="margin-left: .3rem">请选择规格</div>
      </div>
      <span class="btn-right"></span>
    </div>
    <div class="selected">
      <div class="left">
        领劵
        <div style="margin-left: .3rem">暂无可领优惠券</div>
      </div>
      <span class="btn-right"></span>
    </div>
    <div class="selected">
      <!-- <div class="left">
        地址
        <div style="margin-left: .3rem">请选择地址</div>
      </div> -->
      <span class="btn-right"></span>
    </div>
    <!-- 规格 -->
    <specs
      @specs="S_show"
      :level="level"
      :vip="vip"
      :head="names"
      :moneys="qian"
      :longs="lg"
      v-if="names"
      ref="child" 
      v-show="specs_show"
    ></specs>
    <!-- 优惠卷 -->
    <!-- 地址 -->
    <!-- 详情图 -->
    <div
      v-html="imagec"
      class="pull"
    >
 
    </div>

    <!-- <one
      v-show="imgs"
      :data="imgs"
      @xq="imgs_close"
    ></one> -->
    <!-- <img
      src="http://center.huokongjian.net//Uploads/images/20190911/1568192085221300.jpg"
      alt=""
    > -->
    <!-- 底部导航 -->
    <van-goods-action class="foot">
      <!-- <van-goods-action-icon
        icon="chat-o"
        text="客服"
        @click="onClickIcon(0)"
      /> -->
      <van-goods-action-icon
        icon="cart-o"
        text="购物车"
        @click="onClickIcon"
      />
      <!-- <van-goods-action-icon
        v-show="collect"
        icon="star"
        text="已收藏"
        color="#ff5000"
        @click="onClickCollect"
      />
      <van-goods-action-icon
        v-show="!collect"
        icon="star-o"
        text="未收藏"
        color="#ff5000"
        @click="onClickCollect"
      /> -->
      <van-goods-action-button
        type="warning"
        text="选择规格"
        @click="onClickSpecs"
      />
    </van-goods-action>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  NavBar,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Swipe,
  SwipeItem,
  ImagePreview,
  Toast,
} from 'vant'

Vue.use(NavBar)
  .use(Swipe)
  .use(SwipeItem)
  .use(ImagePreview)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Toast)
import Specs from './tians'
// import One from './child/one'

export default {
  created () {
    if (this.$route.query.pushts) {
      this.$store.state.shopid=this.$store.state.shopid? this.$store.state.shopid:this.$route.query.pushts
   }
    this.id = this.$route.query.id
    this.$store.state.ptf=1
    // this.$store.state.cid = this.$route.query.id
    if (JSON.parse(localStorage.getItem('user')).id != 0) {
      this.login = 1
    } else {
    }
    if ([16, 17, 23,30].indexOf(this.$store.state.shopid) == -1) {
      this.jf = true
    } else {
      this.jf = false
    }
    this.deng()

    // console.log(1)
  },
  mounted(){

  },
  data () {
    return {
      jf: true,
      login: 0,
      level: '',
      vip: '',
      id: '',
      names: '',
      qian: '',
      min: '',
      max: '',
      imagec: '',
      img_list: [],
      list: [],
      loading: false,
      finished: false,
      show: false,
      timeOutEvent: 0,
      collect: false,
      specs_show: false,
      imgs: false,
      i_txt: '上划查看详情',
      touchend: false,
      lg: false,
      sp:'',
      lb:true
    }
  },

  methods: {
    getScrollTop () {
      let scrollTop = 0 //滚动高度
      let checkScrollHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      ) //页面总高度
      let getClientHeight = document.documentElement.clientHeight //可视高度
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      let check = checkScrollHeight - scrollTop - getClientHeight
      if (check <= 0) {
        this.i_txt = '上划查看详情'
        this.touchend = true
      } else {
        this.i_txt = '上划加载'
        this.touchend = false
      }
    },
    goimgs () {
      if (this.touchend) {
        this.imgs = true
      }
    },
    onClickLeft () {
      if (this.$route.query.from == 1) {
        this.$router.push('orderList')
      } else {
        this.$router.go(-1)
      }
    },
    spy(){
this.lb=false

      document.getElementById('vi').muted  =  false
    },
     jspy(){
      document.getElementById('vi').muted  =  true
this.lb=true
    },
    look (i) {
      // console.log(this.img_list)
      let images = []
      this.img_list.forEach((v) => {
        images.push(v.image)
      })
      ImagePreview({ images, startPosition: i })
    },
    // dengjihuoq
    //async await
    async deng () {
      // console.log(this.$route.query)
      await this.axios
        .post('userInfo', { store_id: this.$route.query.sid ? this.$route.query.sid : this.$store.state.shopidd })
        .then((res) => {
          // console.log(res)
          if (res.data.code == 1004) {
            localStorage.setItem(
              'token',
              JSON.stringify({ id: res.data.token })
            )
            this.deng()
          }
          if (res.data.code == 200) {
            // console.log(res)
            this.level = res.data.info.level
            this.vip = res.data.info.super_vip
            localStorage.setItem(
              'vip',
              JSON.stringify({ id: res.data.info.super_vip })
            )
            localStorage.setItem(
              'user-level',
              JSON.stringify({ id: res.data.info.level })
            )
          }
          if (res.data.code == 2001) {
            localStorage.setItem('user', JSON.stringify({ id: 0 }))
            Toast(res.data.msg)
            this.$router.push('/login')
          }

        })
        .catch((ref) => { })
      await this.axios
        .post('goodsDetail', {
          store_id: this.$route.query.sid ? this.$route.query.sid : this.$store.state.shopid,
          goods_id: this.$route.query.id,
          user_level: this.level,
        })
        .then((res) => {
          // console.log(res)
          if (res.data.code == 200) {
            if (res.data.data.goodsBasic.mishudingzhi == 0) {
              this.lg = false
            } else {
              this.lg = true
            }
            this.img_list = res.data.data.goodsBanner
            this.imagec = res.data.data.goodsContent
            this.names = res.data.data.goodsBasic.name
            this.min = res.data.data.goodsBasic.min_price
            this.max = res.data.data.goodsBasic.max_price
            this.sp = res.data.data.goodsBasic.fullvideourl
            this.qian =
              res.data.data.goodsBasic.min_price +
              '~' +
              res.data.data.goodsBasic.max_price
          }
          // console.log(1)
          // console.log(this.imagec)
        })
        .catch((ref) => { })
      // console.log(this.vip)
    },
    onClickIcon (i) {
      // Toast('点击图标');
      
      if (this.login == 0) {
        this.$router.push('login')
        return
      }
      if (i == 0) {
        return false

        let uid = JSON.parse(localStorage.getItem('user')).id
        let user_name = JSON.parse(localStorage.getItem('user-name')).id
        let mobile = JSON.parse(localStorage.getItem('user-mobile')).id
        let supers = this.vip ? '超级会员' : '普通会员'
        window.location.href = `https://tb.53kf.com/code/client/43f529e8c4eba0eee3b64ae210fa4e299/1?u_cust_id=${uid}&u_cust_name=${user_name +
          mobile +
          supers}`
      }
      this.$router.push('car')
    },
    onClickButton () {
      // Toast('点击按钮');
    },
    onClickCollect () {
      this.collect = !this.collect
    },
    toRule () {
      this.$router.push('hierarchy')
    },
    async onClickSpecs () {
      
    //   await this.$refs.child.check()
    //   await console.log(this.$store.state.ddtf)
    //   if (this.$store.state.ddtf == "4001") {
        
    //     Toast('您已购买过')
    //     return
        
    // }
      if (this.login == 1) {
        if ([1, 2, 3].indexOf(this.level) != -1) {
          this.specs_show = true
        } else {
          Toast('账号已锁定，请联系客服人员')
        }
      } else {
        Toast('请先登录')
      }
    },
    S_show (v) {
      this.specs_show = v
    },
    imgs_close (v) {
      this.imgs = v
    },
  },
  components: {
    Specs,
    // One
  },
}
</script>
<style lang="less" scoped>
.my-swipe {
  height: 10rem;
  .sp{
    height: 10rem;
    position: relative;
    .xlb{
      position: absolute;
      top: 2%;
      right: 3%;
      z-index: 99;
      img{
        width: 1rem;
      }
    }
    video{
      height: 10rem;
      width: 100%;
    }
  }
}
.pull {
  text-align: center;
  color: #ccc;
  // padding-bottom: 0.5rem;
}
.foot {
  z-index: 3;
}
.product {
  padding-top: 1.2rem;
  padding-bottom: 1.333333rem;
}
.operation {
  padding: 5% 5% 5% 5%;
  .money {
    color: #f23030;
    font-size: 0.6rem;
    font-weight: 700;
    span {
      float: right;
      color: #929292;
      font-weight: normal;
    }
  }
  .title {
    height: 1.2rem;
    line-height: 1.2rem;
    font-size: 0.45rem;
  }
  .equity {
    display: flex;
    height: 0.7rem;
    align-items: center;
    justify-content: space-between;
    background: #f8f5ef;
    color: #333333;
    padding: 0 0.2rem;

    .left,
    .right {
      display: flex;
      align-items: center;
    }

    .left:before {
      content: "";
      background: url("../../assets/crown@2x.png");
      background-size: cover;
      width: 0.45rem;
      height: 0.4rem;
      margin-right: 0.1rem;
    }

    .right:after {
      content: "";
      background: url("../../assets/btn-right.png");
      width: 0.14rem;
      height: 0.24rem;
      background-size: cover;
      margin-left: 0.1rem;
    }
  }
}
.selected {
  padding: 0.1rem 0.5rem 0.1rem 0.2rem;
  min-height: 0.8rem;
  line-height: 1.2rem;
  font-size: 0.5rem;
  color: #a6a6a6;
  position: relative;
  background: #fff;
  border-top: 1px solid #f1f1f1;

  .title {
    margin-right: 0.2rem;
  }

  .number {
    color: #333;
    padding-left: 0.55rem;
  }

  .btn-right {
    position: absolute;
    right: 0.3rem;
    top: 50%;
    margin-top: -0.12rem;
    width: 0.14rem;
    height: 0.24rem;
    background: url(../../assets/btn-right.png) no-repeat;
    background-size: 100% 100%;
  }

  .left {
    display: flex;
    align-items: center;
    font-size: 0.4rem;
    .coupon {
      width: 2.5rem;
      height: 0.5rem;
      background: url("../../assets/coupon.png");
      background-size: cover;
      color: #fff;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 0.5rem;
      margin-left: 0.2rem;
    }
  }
}
</style>
